/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Form_EyebrowInputs */

const es_cap_form_eyebrow = /** @type {(inputs: Cap_Form_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro gratuito`)
};

const gl_cap_form_eyebrow = /** @type {(inputs: Cap_Form_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexistro de balde`)
};

const en_cap_form_eyebrow = /** @type {(inputs: Cap_Form_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free signup`)
};

/**
* | output |
* | --- |
* | "Free signup" |
*
* @param {Cap_Form_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_form_eyebrow = /** @type {((inputs?: Cap_Form_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Form_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_form_eyebrow(inputs)
	if (locale === "en") return en_cap_form_eyebrow(inputs)
	return es_cap_form_eyebrow(inputs)
});